// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".offer[data-v-a25f38f4]{padding:10px 15px;border-radius:10px 10px 0 0}.link[data-v-a25f38f4]{text-decoration:none}.link[data-v-a25f38f4]:hover{text-decoration:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
